// Datos del negocio que la ley pide a la vista para vender en línea (Ley Federal de Protección al Consumidor, art. 76 Bis)
// y en el aviso de privacidad (Ley Federal de Protección de Datos Personales en Posesión de los Particulares 2025, art. 15).
// Los usan la página, las páginas de cada servicio (scripts/paginas-seo.mjs), los términos y el aviso de privacidad.
// Jamez: llena titular, domicilio y teléfono. Mientras falte alguno, los pedidos en línea NO se prenden en la página publicada.
export const NEGOCIO = {
  marca: "Nietzsche Studios",
  titular: "",     // nombre legal como en tu constancia del SAT (persona física o razón social)
  domicilio: "",   // calle y número, colonia, alcaldía, código postal, Ciudad de México
  telefono: "",    // con lada, por ejemplo "55 1234 5678"
  correo: "nietzschestudiosss@gmail.com",
  horario: "Lunes a viernes de 10:00 a 19:00 h (hora del centro de México)",
  horarioEn: "Monday to Friday, 10 am to 7 pm (Mexico City time)",
};
export const NEGOCIO_COMPLETO = !!(NEGOCIO.titular && NEGOCIO.domicilio && NEGOCIO.telefono);
